import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Helmet } from "react-helmet-async";

export default function PageHero({ title, subtitle, breadcrumbs = [], bgImage }) {
  const breadcrumbLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: "https://rukenalazdehar.ae/" },
      ...breadcrumbs.map((b, i) => ({
        "@type": "ListItem",
        position: i + 2,
        name: b.label,
        ...(b.to ? { item: `https://rukenalazdehar.ae${b.to}` } : {}),
      })),
    ],
  };
  return (
    <section className="relative overflow-hidden" style={{ minHeight: 320 }}>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(breadcrumbLd)}</script>
      </Helmet>
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: bgImage ? `url(${bgImage})` : undefined, backgroundColor: "#1a4d2e" }}
      />
      <div className="absolute inset-0 hero-overlay" />
      <div className="relative max-w-7xl mx-auto px-6 pt-24 pb-16 md:pt-32 md:pb-20 text-white">
        <nav className="flex items-center gap-1.5 text-sm text-white/70 mb-5">
          <Link to="/" className="hover:text-white">Home</Link>
          {breadcrumbs.map((b, i) => (
            <React.Fragment key={i}>
              <ChevronRight size={14} className="text-white/40" />
              {b.to ? (
                <Link to={b.to} className="hover:text-white">{b.label}</Link>
              ) : (
                <span className="text-white">{b.label}</span>
              )}
            </React.Fragment>
          ))}
        </nav>
        <h1 className="font-display font-bold text-4xl md:text-5xl tracking-tight">{title}</h1>
        {subtitle && <p className="mt-3 max-w-2xl text-white/85 text-base md:text-lg">{subtitle}</p>}
      </div>
    </section>
  );
}
